import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { Component, ErrorInfo } from 'react';

import ErrorMessageContent from './ErrorMessageContent';
import { Props, State } from './types';

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorMessage = error?.message || String(error);
    const errorStack = error?.stack || '';
    const currentUrl = window?.location?.href;

    const logPayload = {
      error,
      errorMessage,
      errorStack,
      errorInfo,
      currentUrl,
    };

    datadogRum.addAction('React ErrorBoundary caught an error', {
      message: errorMessage,
      currentUrl,
    });

    // Report error to Datadog RUM
    datadogRum.addError(error, {
      source: 'room-error-boundary',
      componentStack: errorInfo?.componentStack,
      url: currentUrl,
    });

    // Report error to Datadog Logs
    datadogLogs.logger.error('Provider Portal Client Has Crashed', logPayload);

    if (process.env.NODE_ENV === 'development') {
      console.error('Provider Portal Client Has Crashed', logPayload);
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorMessageContent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
